import * as ents from '@attain-apps/entities'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/**
 * Loads functional usage when the laboratories assigned to this Lab Service
 * record change (added or removed) and the current methodology is Auto Lab
 * Based. Lab-based allocations are derived from the assigned labs, so this keeps
 * the record's functional usage in sync without requiring a page refresh.
 */
export const loadForCurrentEntityOnLabAssignmentChange = store.effects.create(
  (feature: Plugin['feature'], plugin: Plugin) =>
    ec.models.CollectionProducer.getEc$(ec.Name.Predefined.SpaceLabAssignment, {
      waitUntilReady: true,
    }).pipe(
      rxjs.switchMap(labAssignmentsEc =>
        labAssignmentsEc.plugins.editingPlugin.feature.actions.submit.success
          .observe()
          .pipe(
            rxjs.withLatestFrom(plugin.selectors.functionalUsage.asObservable),
            rxjs.filter(
              ([, functionalUsage]) =>
                functionalUsage?.functionalizationMethodology ===
                ents.extra.space.Record.FunctionalUsage.Methodology
                  .AutoLabBased,
            ),
            rxjs.map(() =>
              feature.actions.loadForCurrentEntity.request
                .from(
                  '(effect) load for current entity on lab assignment change',
                )
                .create(),
            ),
          ),
      ),
    ),
)
